// extracted by mini-css-extract-plugin
export default {"component":"SellerStories__component-P4eD","stories":"SellerStories__stories-SZF8"};